module.exports = __webpack_public_path__ + "static/media/8.4c3cc26c.jpg";